

<div mat-dialog-title>
  {{ data.modalTitle }}
</div>


<div mat-dialog-content>

  <div class="search-box mat-elevation-z3">
    <mat-icon class="search-box-prefix">search</mat-icon>

    <input [(ngModel)]="search"
      (ngModelChange)="onChangeResearch($event)"
      name="search"
      type="search"
      class="search-box-search"
      placeholder="Rechercher">

      @if (search?.length > 0) {
        <div>
          <button mat-icon-button (click)="search = ''; onChangeResearch(null);">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      }
    </div>



    <div class="container-mat-table container-mat-table-sticky">
      <table class="no-zebra mat-table-data-list mat-table-dense mat-table-head-ultradense" mat-table matSort [dataSource]="utilisateurs" (matSortChange)="changeSort($event)">

        <ng-container matColumnDef="nom">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
          <td mat-cell *matCellDef="let element">
            {{element.nom | uppercase }}  {{element.prenom}}
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>E-mail</th>
          <td mat-cell *matCellDef="let element">
            {{element.email}}
          </td>
        </ng-container>

        <ng-container matColumnDef="nationalites">
          <th mat-header-cell *matHeaderCellDef>Nat.</th>
          <td mat-cell *matCellDef="let element">
            @for (country of element.nationalites; track country) {
              <span
                matTooltip="{{ country.label }}"
                class="{{ (element.nationalites.length === 1) ? 'flag':'flag flag-small' }}"
                >
                <i class="flag-icon flag-icon-{{country.code|lowercase}}"></i>
              </span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="utilisateurRoles">
          <th mat-header-cell  *matHeaderCellDef>Roles</th>
          <td mat-cell *matCellDef="let element">
            @if (!element.utilisateurRoles || element.utilisateurRoles.length === 0) {
              <span>
                CANDIDAT
              </span>
            }

            @for (role of element.utilisateurRoles; track role; let i = $index) {
              <span class="role-{{ role.code }}">
                {{role.label}}
              </span>
              @if (element.utilisateurRoles[i+1]) {
                <span> - </span>
              }
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell  *matHeaderCellDef mat-sort-header>&nbsp;</th>
          <td mat-cell *matCellDef="let element" width="70px">
            <button (click)="submitWithSelection(element)" mat-stroked-button>
              {{ 'general.selectionner' | translate }}
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>

      </table>
      <mat-paginator  class="mat-paginator-sticky" [pageSize]="10" [length]="total"
        [pageSizeOptions]="pageSizeOptions"  (page)="onPaginatorPageChange()"
      showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <div mat-dialog-actions>
    <button [mat-dialog-close]="null" mat-button mat-flat-button color="primary" >{{ 'general.annuler' | translate }}</button>
  </div>
